export default "__VITE_ASSET__c54da705__"